/* eslint-disable max-len */
import React from 'react';

import { isMobile } from '@common/utils/platform';
import ConnectWithRM from '~referral/images/referral_modal/connect-with-rm.svg';
import JoinScaler from '~referral/images/referral_modal/join-scaler.svg';
import ReferFriend from '~referral/images/referral_modal/refer-friend.svg';
import Rewards from '~referral/images/referral_modal/rewards.svg';

import men from '~referral/images/men.webp';
import ugReferralReward from '~referral/images/ug_referral_reward.webp';
import UGBannerImg1
  from '~referral/images/ug_banner/b_img_1.webp';
import UGBannerImg4
  from '~referral/images/ug_banner/b_img_4.webp';
import UGReferralModalReminderHeading
  from '~referral/images/ug_referral_modal/reminder-heading.webp';
import UGReferralModalPostSolvingHeading
  from '~referral/images/ug_referral_modal/post-solving-heading.webp';
import UGReferralModalPostPurchaseHeading
  from '~referral/images/ug_referral_modal/post-purchase-heading.webp';

export const STREAK_SHARE_FORM_LINK = 'https://forms.gle/Fdc1VdHPx1vg1jbEA';
export const STREAK_SHARE_REWARD = '200';
export const STREAK_REWARD_THRESHOLD = 100;

export const BANNER_TYPE_KEY = 'ug-sst-referral-banner-type';

export const SOCIAL_LINKS = {
  twitter: 'https://twitter.com/intent/tweet',
  linkedin: 'https://www.linkedin.com/shareArticle',
  whatsappWeb: 'https://web.whatsapp.com/send',
  whatsappMobile: 'https://wa.me/',
};

export const SOCIAL_DATA = {
  twitter: {
    url: ({ url }) => `${SOCIAL_LINKS.twitter}?url=${url}`,
  },
  linkedin: {
    url: ({ url }) => `${SOCIAL_LINKS.linkedin}?url=${url}`,
  },
  whatsapp: {
    url: ({ url }) => (isMobile() ? `${SOCIAL_LINKS.whatsappMobile}?text=${url}`
      : `${SOCIAL_LINKS.whatsappWeb}?text=${url}`),
  },
};

export const MENTEE_COURSE_PRODUCT = {
  academy: 'academy',
  dataScience: 'data_science',
};

export const REWARDS_CALC_BANNER_DATA = {
  bannerC: {
    title: 'Calculate your REWARDS right away',
    subTitle: `Now you can determine how many rewards
    you will receive for each successful referral `,
  },
  bannerB: {
    title: 'Be sure to calculate your incentives now',
    subTitle: `Start recommending your friends after
    viewing the benefits you'll receive for each successful referral.`,
  },
  bannerA: {
    title: 'Refer friends & receive a plenty of incentives',
    subTitle: `Before you start recommending friends,
    have a look at the benefits you'll receive for each successful referral`,
  },
};

export const REFERRAL_MODAL_CONFIG = {
  title: 'Refer Learners! and see your influence grow',
  subtitle: `Help learners from your network join Scaler’s Premium Programs.
    You earn rewards while helping them succeed.`,
  pointers: [
    `You get Good Karma + ₹10,000 Cash + Goodies worth ₹2,000 and 200 Scaler
      Coins.`,
    `They get ₹10,000 off on the course.`,
  ],
  steps: [
    { image: ConnectWithRM, title: 'Connect with <br/> Referral Manager' },
    { image: ReferFriend, title: 'Refer <br/> a Learner' },
    { image: JoinScaler, title: 'Learner <br/> Joins Scaler' },
    { image: Rewards, title: 'You Receive <br/> Rewards' },
  ],
  rcbBtnText: 'Talk to Referral Manager',
  redirectBtnText: 'Know More',
  redirectLink: '/invite-friends/',
};

export const CALLBACK_SUCCESS_MODAL_CONFIG = {
  title: 'You will receive a call from your referral manager soon!',
  subtitle: 'They will provide you with guidance on the same.',
  helperText: 'Check rewards while you wait for a call from referral manager',
  btnText: 'Try Rewards Calculator',
  redirectLink: '/invite-friends?rewards-calc',
};


export const MENTOR_REFERRAL_BANNER_CONFIG = {
  not_scheduled: {
    title: 'Here is your ticket to owning this speaker!',
    subtitle: `Marshall Emberton II Speaker +
    ₹10,000 in cash by referring your friends to Scaler!`,
    callback_btn_text: 'Know More on Call',
    redirect_btn_text: 'Know more about the referral program',
    redirect_link: '/invite-friends/',
  },
  scheduled: {
    title: 'You will receive a call from your referral manager soon!',
    subtitle: `They will guide you on how to get
     the Marshall Emberton II Speaker.`,
    redirect_btn_text: 'Try the Referral Rewards Calculator',
    redirect_link: '/invite-friends/?rewards-calc',
  },
  title: 'Refer Learners! Boost your Impact & Earnings',
  description: {
    academy: `Help learners from your network join Scaler’s Academy and
     Data Science Program.Earn exciting perks for every successful referral.`,
  },
  rcbBtnText: 'Talk to Referral Manager',
  subBtnText: 'Know More',
  link: '/invite-friends/',
  userRewards: {
    title: 'You get',
    list: [
      '₹10,000 cash',
      '₹2,000 vouchers',
    ],
  },
  friendRewards: {
    title: 'They get',
    list: [
      '₹10,000 discount',
      'Best Learning',
    ],
  },
};

export const SST_ROLLING_BANNER_CONTENT = {
  VersionA: {
    heading: `A 4 Year Undergraduate Program 
              delivered by 100+ leaders from Google, Microsoft and more`,
    subHeading: `60+ students left offers from top colleges like IIT, NIT,
                 IIIT to join SST.`,
    buttonCta: `Find out why!`,
    ctaLink: '/school-of-technology/',
    source: 'ug_rolling_banner_A',
  },
  VersionB: {
    heading: `A 4 Year Undergraduate Program 
              delivered by 100+ leaders from Google, Microsoft and more`,
    subHeading: `Not everyone gets in. Only 191 students selected out of
                 54k applications in 2023.`,
    buttonCta: `Know more`,
    ctaLink: '/school-of-technology/',
    source: 'ug_rolling_banner_B',
  },
  VersionC: {
    left_side_name: `Ayaan Khan`,
    left_side_title: `First Year Student @ SST`,
    left_side_desc: `Developed a program to control a
    racing game using only hand gestures.`,
    left_side_buttonCta: `View Ayaan's Project`,
    // eslint-disable-next-line max-len
    left_side_buttonCta_link: `https://www.linkedin.com/posts/ayaankhan2812_computervision-scalerschooloftechnology-activity-7187535044280815616-g0iF?utm_source=share&utm_medium=member_desktop`,
    subHeading: `We are Reimagining Engineering Education in India`,
    buttonCta: `Explore Scaler's UG Programme`,
    ctaLink: '/school-of-technology/#curriculum',
    source: 'ug_rolling_banner_C',
  },
  VersionD: {
    left_side_heading_top: `From no graduation to leading 200+ engineers`,
    left_side_name: `Shubash Choudhary`,
    left_side_subname: `CTO Dukaan`,
    left_side_title: `First Year Student @ SST`,
    left_side_desc: `Hosts a masterclass for our budding
    techies at Scaler School of Technology`,
    left_side_buttonCta: `Check it out`,
    left_side_buttonCta_link: `https://www.youtube.com/watch?v=0moVCRK6ATc`,
    subHeading: `We are Reimagining Engineering Education in India`,
    buttonCta: `Explore Scaler's UG Programme`,
    ctaLink: '/school-of-technology/#curriculum',
    source: 'ug_rolling_banner_D',
  },
};

export const REFERRAL_LOCAL_STORAGE_KEYS = {
  firstVisit: '__Referrals__FirstVisit__',
  newSstBannerKey: '__referrals-sst-rolling-banners-new__',
};

export const SSB_BANNER_CONTENT = {
  VersionA: {
    heading: `India’s Only B-School Built by Industry Leaders, 
               for Industry Leaders.`,
    heading2: `PGP IN MGMT & TECH (PGP-MT)`,
    subHeading: `Limited Seats for the first batch`,
    buttonCta: `Know More`,
    ctaLink: '/school-of-business/',
    source: 'ssb_banner_referrals_know_more',
    rcbCta: 'Refer Now',
    rcbSource: 'ssb_banner_referrals_rcb',
  },
};

/*
Power referrers are users who have had >=4 referrals.
Some banners are not shown to power referrers.
*/
export const BLACKLISTED_BANNERS_FOR_PR = [
  'HoliBanner',
];

export const COUPON_CONFIG = {
  invalidCouponError: `
    That one didn't work. Make sure the referral code is valid.
  `,
  couponMissingError: 'Please enter referral code!',
  touchpoint: {
    title: 'Have a Referral Code?',
  },
  appliedTouchpoint: {
    title: 'You have saved ₹10,000 with your referral code!',
    description: `Get ready to upskill with Scaler's Online Program. 
      Our team will contact you shortly to assist with the next steps.`,
  },
  apply: {
    title: 'Have a Referral Code?',
    cta: 'Apply',
  },
  applied: {
    title: 'You have saved ₹10,000!',
    description: `Get ready to upskill with Scaler's Online Program. 
      Our team will contact you soon!`,
    cta: 'Applied',
  },
  entranceTest: {
    title: 'Save an Extra ₹10,000 Off  with a referral code',
    description: `
      Apply your referral code now to access this exclusive discount`,
  },
  paymentDone: {
    title: 'Payment Already Completed',
    description: `Thank you for your payment. Referral codes cannot be applied 
      after payment has been made.`,
  },
  greenCheckAssetLink: 'https://d2beiqkhq929f0.cloudfront.net/public_assets'
    + '/assets/000/084/777/original/green-check.gif?1722844705',
};

export const PROGRAM_OPTIONS = [
  { name: 'Software Development', value: 'software_development', isNew: false },
  { name: 'DSML', value: 'data_science', isNew: false },
  { name: 'DevOPS', value: 'devops', isNew: false },
  { name: 'AI & ML ', value: 'ai_ml', isNew: true },
  {
    name: 'Scaler School of Technology',
    value: 'school_of_technology',
    isNew: false,
  },
  {
    name: 'Scaler School of Business',
    value: 'school_of_business',
    isNew: false,
  },
];

export const INVITE_AND_EARN_PAGE = '/invite-friends/';

const getWhatsappMessage = (couponCode) => (
  `Hey!

  I’ve been studying at Scaler School of Technology, and honestly, it’s been incredible.
  The community, the exposure, everything—it feels like the right place to be if you’re 
  serious about tech. We have been building drones and using vision pro from the first year!

  Since you’re looking into colleges, why not consider joining me here?
  If you take the NSET test, use this code ${couponCode} to save ₹500 
  on the fee. 
  
  Would be awesome to have you on campus. What do you think? 
  Check out Scaler School of Technology: https://www.scaler.com/school-of-technology/application/?utm_source=SST_student_referral`
);

export const shareMessage = (couponCode) => {
  const whatsappMessage = getWhatsappMessage(couponCode);
  const content = `https://wa.me/?text=${encodeURIComponent(whatsappMessage)}`;
  window.open(content, '_blank');
};

export const UG_REFERRAL_BANNER_CONFIGS = {
  not_referred: {
    title: 'Earn double for your Referral reward in 1 click!',
    Image: (<img
      src={UGBannerImg4}
      alt="banner_image"
      className="ug-referral-banner-sst__image__v2"
    />),
    description: (
      <>
        <b>FOR A LIMITED TIME : Earn 2000 coins </b>
        for your first referral along with
        <b> Rs.1000 reward money.</b>
        <br />
        Your Friend get a
        <b> ₹500 NSET fee waiver for them.</b>
      </>
    ),
    showShare: true,
    showRefer: false,
    showKnowMore: true,
    darkVariant: true,
  },
  referred: {
    title: 'Continue your Referral Rewards',
    Image: (<img
      src={UGBannerImg4}
      alt="box-with-vouchers"
      className="ug-referral-banner-sst__image__v2"
    />),
    description: (
      <>
        Keep securing
        {' '}
        <b>Rs.1000 reward money and 1000 coins on each referral.</b>
      </>
    ),
    showShare: true,
    showRefer: false,
    showKnowMore: true,
    darkVariant: false,
  },
  store: {
    title: 'Not all superheros wear a cape, some wear cool tees too',
    Image: (<img
      src={UGBannerImg1}
      alt="banner_image"
      className="ug-referral-banner-sst__image__v2"
    />),
    description: (
      <>
        Treat yourself for helping a friend kickstart their
        tech journey! Redeem your Scaler Coins from curated
        products below.
        {' '}
        <b>
          Got more friends? Earn 1000 Scaler Coins per NSET
          registration and a ₹1000 reward money for every
          test attempt!
        </b>
      </>
    ),
    showShare: true,
    showRefer: false,
    showKnowMore: true,
    darkVariant: false,
  },
};

export const NOT_REFERRED_UG_REFER_CARD_LEFT = {
  title: 'YOU GET',
  money: '2000',
  heading: (
    <>
      coins on 1st referral and
      {' '}
      <span>reward money worth ₹1000</span>
    </>
  ),
  img: ugReferralReward,
  heading_inactive: 'Scaler Coins on 1st referral & reward money worth upto ₹1000 ',
};

export const UG_REFER_CARD_LEFT = {
  title: 'YOU GET',
  money: '1000',
  heading: (
    <>
      Scaler Coins &
      {' '}
      <span>reward money worth ₹1000 on each referral</span>
    </>
  ),
  img: ugReferralReward,
  heading_inactive: 'Scaler Coins & reward money worth ₹1000 on each referral',
};

export const UG_REFER_CARD_RIGHT = {
  title: 'YOUR FRIEND GETS',
  money: '₹500',
  heading: 'OFF on NSET Fees',
  img: men,
};

export const UG_REFERRAL_POPUP_MODAL_DATA = {
  reminder: {
    headingImg: (
      <img
        src={UGReferralModalReminderHeading}
        alt="Earn more Scaler coins"
        className="ug-referral-popup-modal__heading-img"
      />
    ),
  },
  post_purchase: {
    headingImg: (
      <img
        src={UGReferralModalPostPurchaseHeading}
        alt="Earn more Scaler coins"
        className="ug-referral-popup-modal__heading-img"
      />
    ),
  },
  post_problem_solved: {
    headingImg: (
      <img
        src={UGReferralModalPostSolvingHeading}
        alt="Earn more Scaler coins"
        className="ug-referral-popup-modal__heading-img"
      />
    ),
  },
  not_referred_title: (
    <>
      Now earn
      <span className="ug-referral-popup-modal__main-title--highlight-1">&nbsp; 2000 coins for your first referral &nbsp;</span>
      along with
      <span className="ug-referral-popup-modal__main-title--highlight-2">&nbsp; Rs.1000 reward money &nbsp;</span>
    </>
  ),
  referred_title: (
    <>
      Get rewards worth
      <span className="ug-referral-popup-modal__main-title--highlight-1">&nbsp; 1000 coins on every NSET registration &nbsp;</span>
      along with
      <span className="ug-referral-popup-modal__main-title--highlight-2">&nbsp; Rs.1000 reward money &nbsp;</span>
    </>
  ),
};
